/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../api';
import MainContainer, { GlobalStyles } from '../components/MainContainer';
import StylesContext from '../context/StylesContext';
import StyledContainer from '../components/StyledContainer';
import StyledTitle from '../components/StyledTitle';
import menuItemsProps from '../interfaces/MenuItemProps';
import MenuItem from '../components/MenuItem';
import NavButtons from '../components/NavButtons';
import VideoContext from '../context/VideoContext';
import VideoPlayer from '../components/VideoPlayer';
import BackButton from '../components/Buttons/BackButton';
import StyledImage from '../components/StyleImage';
import { useLanguage } from '../hooks/languageService';
import useSessionStorage from '../hooks/useSessionStorage';
import StyledText from '../components/StyledText';
import { categoriesPath, subcategoriesPath } from '../helpers/menuRoutes';

interface paramsProps {
  menu: string;
  category: string;
  subcategory?: string;
};

const noItems = {
  'pt-BR': 'Não há itens nesta categoria.',
  'en-US': 'No items in this category.',
  'es-ES': 'No hay artículos en esta categoría.'
}
const MenuItems = () => {
  //@ts-ignore
  const { menu, category, subcategory } = useParams<paramsProps>();
  const [items, setItems] = useState<Array<menuItemsProps>>();
  const [currentIndex, setCurrentIndex] = useState<number>(0);
  const { styles, setStyles } = useContext(StylesContext);
  const { isVideo, videoSrc, setIsVideo } = useContext(VideoContext);
  const { selectedLanguage } = useLanguage();
  const {getStylesFromSessionStorage} = useSessionStorage();
  const history = useNavigate();

  const handleNext = () => {
    if (items?.length) {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % items.length);
    };
  };

  const handlePrev = () => {
    if (items?.length) {
      setCurrentIndex((prevIndex) => (prevIndex - 1 + items.length) % items.length);
    }
  };

  const handleBackBtn = () => {
    setIsVideo(false);
  }

  // com subcategoria o voltar sobe um nível só, para a lista de subcategorias
  const handleBackToList = () => {
    history(subcategory ? subcategoriesPath(menu, category) : categoriesPath(menu));
  };

  useEffect (() => {
    const getData = async () => {
      try {
        const langId = selectedLanguage.split('-')[0];
        const langEndpoint = langId.includes('pt') ? '' : `-${langId}`;
        const subcategoryFilter = subcategory ? `&subcategory_name=${encodeURIComponent(subcategory)}` : '';
        const { data } = await api.get(
          `menu_itens/category/?url_id=${menu}${langEndpoint}&category_name=${encodeURIComponent(category || '')}${subcategoryFilter}`
        );
        setItems(data);
        setCurrentIndex(0);
      } catch(error: any) {
        console.error(error.message);
      }
    };
    getData();
  }, [menu, category, subcategory, selectedLanguage]);
  
  useEffect(() => {
    const getStyles = async () => {
      try {
        const stylesSessionStorage = getStylesFromSessionStorage();
        if (stylesSessionStorage) {
          setStyles(stylesSessionStorage);          
        } else {
          const { data } = await api.get(`menu_styles/${menu}`);
          setStyles(data);
        };
      } catch(error: any) {
      console.error(error.message);
      }
    }
    getStyles();
  }, [menu]);
  
  return (
    <MainContainer className='menu_items_main_container' $backgroundColor={styles.bgColor}>
      <GlobalStyles $backgroundColor={styles?.bgColor}/>
      {
        items?.length ? (
          !isVideo ? (
            <>          
            <StyledContainer className='menu_items_container_title_icon'>
              <BackButton
                color={styles.textColor}
                className='menu_items_back_btn'
                onClickFunc={handleBackToList}
              />
              <StyledContainer className='category_item_name_container'>
                <img src={ items && ((subcategory && items[0].subcategory_icon) || items[0].category_icon) } alt='icone da categoria' />
              </StyledContainer>
              <StyledContainer className='menu_items_title_wrapper'>
                {
                  // com subcategoria o título é a subcategoria e a categoria vira o caminho acima
                  subcategory && (
                    <StyledText className='menu_items_breadcrumb' $textColor={styles.textColor}>
                      {category}
                    </StyledText>
                  )
                }
                <StyledTitle
                  className='title_menu_items'
                  $textColor={styles.textColor}
                >
                  {(subcategory || category)?.toUpperCase()}
                </StyledTitle>
              </StyledContainer>
            </StyledContainer>
            {
              items?.length && (
                <>
                  <MenuItem menu_item={items[currentIndex]} handleNext={handleNext} handlePrev={handlePrev} />
                </>
              )
            }
            <NavButtons className='nav_buttons_container' />
            </>
          ) : (
            <StyledContainer className='video_player_menu_item_wrapper'>
              <StyledContainer className='video_player_back_btn'>
                <BackButton onClickFunc={handleBackBtn} color={styles.btnBgColor} className='back_btn_video_player' />
                <StyledContainer className='logo_video_player_wrapper'>
                  <StyledImage src={ styles?.logoImg } className='video_player_logo'/>  
                </StyledContainer>
              </StyledContainer>
              <StyledContainer className='video_player_wrapper_full'>
                <VideoPlayer src={ videoSrc } autoPlay={true} controls={true}/>
              </StyledContainer>
            </StyledContainer>
          )
        ) : (
          <StyledContainer className='menu_items_empty_container'>
            <BackButton
              color={styles.textColor}
              className='menu_items_back_btn'
              onClickFunc={handleBackToList}
            />
            <h2>{noItems[selectedLanguage as keyof typeof noItems]}</h2>
          </StyledContainer>
        )
      }
      
    </MainContainer>
  )
}

export default MenuItems;